import { PriceRow } from 'components';


export const CollectRow = ({ title, value, type }) => {
  return(
    <div className='collect-row-box'>
      <p className='collect-row-title'>{title}</p>
      <p className='collect-row-value'>{
        type === 'price' ?
          <PriceRow info={value}/>
          :
          <>{value}</>
      }</p>
    </div>
  )
}